
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("b9VQF", function(module, exports) {

$parcel$export(module.exports, "PersistentCollapsibleSection", () => $d771808394960505$export$a7b76557e2d17008);
$parcel$export(module.exports, "SpacePersistentCollapsibleSection", () => $d771808394960505$export$d1e437087c56a8f2);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $e9zUf = parcelRequire("e9zUf");

var $ieevf = parcelRequire("ieevf");

var $1AUIX = parcelRequire("1AUIX");

var $j3kZx = parcelRequire("j3kZx");
const $d771808394960505$var$getInitialExpandedState = (sectionName, sessionStorageKey, defaultExpanded)=>{
    if ((0, $e9zUf.confluenceSessionStorageInstance).doesContain(sessionStorageKey)) {
        const sideNavSectionStates = (0, $e9zUf.confluenceSessionStorageInstance).getItem(sessionStorageKey);
        return sideNavSectionStates[sectionName] ?? defaultExpanded;
    }
    return defaultExpanded ?? true;
};
const $d771808394960505$export$a7b76557e2d17008 = ({ renderAfterIconButton: renderAfterIconButton, children: children, defaultIsExpanded: defaultIsExpanded, headerTitle: headerTitle, onClick: onClick = ()=>{}, sectionName: sectionName, sessionStorageKey: sessionStorageKey, tooltipContent: tooltipContent })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ieevf.CollapsibleSection), {
        renderAfterIconButton: renderAfterIconButton,
        headerTitle: headerTitle,
        initialExpandedState: $d771808394960505$var$getInitialExpandedState(sectionName, sessionStorageKey, defaultIsExpanded),
        onClick: (isOpen)=>{
            onClick(isOpen);
            (0, $1AUIX.updateExpandedState)({
                isOpen: isOpen,
                sectionKey: sectionName,
                sessionStorageKey: sessionStorageKey
            });
        },
        tooltipContent: tooltipContent
    }, children);
};
const $d771808394960505$export$d1e437087c56a8f2 = ({ renderAfterIconButton: renderAfterIconButton, children: children, headerTitle: headerTitle, sectionName: sectionName, tooltipContent: tooltipContent, collapsedByDefault: collapsedByDefault })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isExpanded: isExpanded, onExpansionToggle: onExpansionToggle } = (0, $j3kZx.useSpacePersistentExpansion)({
        sectionName: sectionName,
        collapsedByDefault: collapsedByDefault
    });
    const onClick = (0, $gwFzn.useCallback)((isOpen)=>{
        // Not calling onExpansionToggle here because it is passed in as setIsOpen
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: !isOpen ? 'opened' : 'closed',
                actionSubject: 'collapsibleSectionHeader',
                source: 'sideNavigation',
                attributes: {
                    section: sectionName
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        sectionName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ieevf.ControlledCollapsibleSection), {
        renderAfterIconButton: renderAfterIconButton,
        headerTitle: headerTitle,
        isOpen: isExpanded,
        setIsOpen: onExpansionToggle,
        onClick: onClick,
        tooltipContent: tooltipContent
    }, children);
};

});
parcelRegister("1AUIX", function(module, exports) {

$parcel$export(module.exports, "updateExpandedState", () => $45f2e91b3fe13927$export$322e23ed7d99ab86);

var $e9zUf = parcelRequire("e9zUf");
const $45f2e91b3fe13927$export$322e23ed7d99ab86 = ({ isOpen: isOpen, sectionKey: sectionKey, sessionStorageKey: sessionStorageKey })=>{
    const expandedStates = (0, $e9zUf.confluenceSessionStorageInstance).getItem(sessionStorageKey);
    if (expandedStates) {
        expandedStates[sectionKey] = isOpen;
        (0, $e9zUf.confluenceSessionStorageInstance).setItem(sessionStorageKey, {
            ...expandedStates
        });
    }
};

});

parcelRegister("j3kZx", function(module, exports) {

$parcel$export(module.exports, "useSpacePersistentExpansion", () => $748c02fb00e52ac9$export$a0aa95d2fbef03e8);

var $gwFzn = parcelRequire("gwFzn");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");
const $748c02fb00e52ac9$export$a0aa95d2fbef03e8 = ({ sectionName: sectionName, collapsedByDefault: collapsedByDefault = false, forceExpand: forceExpand = false })=>{
    const [isExpandedManually, setIsExpandedManually] = (0, $gwFzn.useState)();
    const isDefaultExpanded = (0, $gwFzn.useMemo)(()=>$748c02fb00e52ac9$var$getExpandedStateBySpace(sectionName, collapsedByDefault), [
        sectionName,
        collapsedByDefault
    ]);
    const hasManualExpansion = isExpandedManually !== undefined;
    const isExpanded = hasManualExpansion ? isExpandedManually : forceExpand || isDefaultExpanded;
    const onExpansionToggle = (0, $gwFzn.useCallback)((newIsExpanded)=>{
        setIsExpandedManually(newIsExpanded);
        $748c02fb00e52ac9$var$updateExpandedStateBySpace(sectionName, newIsExpanded);
    }, [
        sectionName
    ]);
    return {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    };
};
const $748c02fb00e52ac9$var$getExpandedStateBySpace = (sectionName, collapsedByDefault)=>{
    if ((0, $e9zUf.confluenceLocalStorageInstance).doesContain((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES)) {
        const sideNavExpansionStates = (0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES);
        if (typeof sideNavExpansionStates[sectionName] === 'boolean') return sideNavExpansionStates[sectionName];
    }
    return !collapsedByDefault;
};
const $748c02fb00e52ac9$var$updateExpandedStateBySpace = (sectionName, isExpanded)=>{
    const sideNavExpansionStates = (0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES) || {};
    (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES, {
        ...sideNavExpansionStates,
        [sectionName]: isExpanded
    });
};

});



//# sourceMappingURL=PersistentCollapsibleSection.81cc8d2c.js.map
